const utils = require('./utils');
const $ = require('jquery');
const messageCtrl = require('./message-controller');
const toastService = require('utils/toast-service');
const ajaxIndicator = require('utils/ajax-indicator');

var apiController = {

  _rootUrl: '/api',

  listeners: [],

  profile: {
    authenticated: false,
    login: '',
    completeName: '',
    userName: '',
    token: ''
  },

  isAuthenticated(){
    return apiController.profile.authenticated;
  },

  ajax(oParams) {

    var params = utils.extend({},oParams);

    apiController.actionName = params.actionName;

    ajaxIndicator.setRunning(true);

    messageCtrl.clearMessage();

    params.headers = (params.headers || {});

    if (apiController.isAuthenticated()) {
      params.headers['auth-token'] = apiController.profile.token;
    }

    params.headers['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    params.headers['Cache-Control'] = 'no-cache';
    params.headers['Pragma'] = 'no-cache';

    if (params.url.substring(0,apiController._rootUrl.length) != apiController._rootUrl) {
      params.url = apiController._rootUrl + params.url;
    }

    if (!params.contentType) {
      params.contentType = 'application/json';
    }

    if (typeof params.data !== "string") params.data = JSON.stringify(params.data);

    var promise = $.ajax(params);

    promise.then(apiController.ajaxFinished);
    promise.error(apiController.handleError);

    return promise;
  },

  ajaxFinished(){
    ajaxIndicator.setRunning(false);
  },

  get(url) {
    return apiController.ajax({method: 'get', url: url});
  },

  del(url) {
    return apiController.ajax({method: 'delete', url: url});
  },

  post(url,data) {
    return apiController.ajax({method: 'post', url: url, data: data});
  },

  decodeJwt(token){
    var info = utils.decodeJwt(token);
    if (info.login) {
      apiController.profile.login = info.login;
      apiController.profile.userName = info.login;
      apiController.profile.completeName = info.nomeCompleto;
      apiController.profile.token = token;
      apiController.profile.authenticated = true;
      apiController.profile.statusSenha = info.statusSenha || '0';
    }
  },

  login(userName,password) {

    var credentials = {
      userName: userName,
      password: password
    };

    messageCtrl.clearMessage();

    return $.ajax({
      url: apiController._rootUrl + '/login',
      method: 'post',
      data: JSON.stringify(credentials),
      contentType: 'application/json',
      success: function(data) {
        apiController.acessos = data.acessos;
        apiController.decodeJwt(data.token);
        apiController.saveProfile();
      },
      error: function(response){
        response.status = 401;
        apiController.handleError(response);
        //messageCtrl.setErrorMessage(utils.getAjaxError(response,'Erro ao efetuar login'));
        toastService.toast(utils.getAjaxError(response,'Erro ao efetuar login'),'danger');
      }
    });
  },

  isResettingPass(){
    return window.location.pathname.substring(0,10) == '/resetpass';
  },

  changePass(curPass, newPassword){

    var data = {
      senhaAtual: curPass,
      novaSenha: newPassword
    };

    return apiController.ajax({
      url: '/changepass',
      method: 'post',
      data: JSON.stringify(data),
      contentType: 'application/json',
      success: function(data){
        apiController.decodeJwt(data.token);
        apiController.saveProfile();
        if (apiController.isResettingPass()) {
          window.location.pathname = "/";
        }
      }
    });
  },

  forgotPass(email){

    var data = {
      email: email
    };

    return $.ajax({
      url: apiController._rootUrl + '/forgotpass',
      method: 'post',
      data: JSON.stringify(data),
      contentType: 'application/json',
      success: function(data) {
        toastService.toast('E-mail enviado com sucesso','success');
      },
      error: function(response){
        toastService.toast(utils.getAjaxError(response,'Erro ao enviar e-mail'),'danger');
      }
    });
  },

  saveProfile(){
    //emit broadcast
    apiController.emit();

    //salva informação do profile na sessionStorage
    if (window.sessionStorage) {
      if (apiController.profile.authenticated && apiController.profile.token) {
        window.sessionStorage.setItem('profile',apiController.profile.token);
      } else {
        window.sessionStorage.removeItem('profile');
      }
    }
  },

  clearProfile(){
    apiController.profile.authenticated = false;
    apiController.profile.userName = '';
    apiController.profile.completeName = '';
    apiController.profile.token = '';
    apiController.profile.login = '';
    apiController.saveProfile();
  },

  logout(){
    apiController.clearProfile();
  },

  getUserName(){
    return apiController.profile.userName;
  },

  handleError(response) {

    apiController.ajaxFinished();

    //forbidden
    if (response.status == 401) {
      apiController.clearProfile();
      location.hash = '#/';
    } else {
      var caption = (apiController.actionName) ? 'Erro ao ' + apiController.actionName : '';
      //messageCtrl.setErrorMessage(utils.getAjaxError(response,caption));
      toastService.toast(utils.getAjaxError(response,caption),'danger');
    }

  },

  checkToken(){
    apiController.get('/checktoken')
      .success(function(acessos){
        apiController.acessos = acessos;
        apiController.emit();
      })
      .error(function(response){
        apiController.clearProfile();
        location.hash = '#/';
      });
  },

  addListener(callback){
    if (apiController.listeners.indexOf(callback) == -1) {
      apiController.listeners.push(callback);
    }
  },

  removeListener(callback) {
    apiController.listeners = apiController.listeners.filter(function(c1){
      return c1 != callback;
    });
  },

  emit(){
    apiController.listeners.map(function(callback){
      callback();
    });
  },

  mixin: {
    componentDidMount(){
      apiController.addListener(this.refresh);
    },
    componentWillUnmount(){
      apiController.removeListener(this.refresh);
    },
    refresh(){
      this.setState({});
    }
  }

}

/**
 *** Procura informação do token na session store
 ***
 ***/
if (window.sessionStorage) {
  var token = window.sessionStorage.getItem('profile');
  if (token) {
    apiController.decodeJwt(token);
    apiController.checkToken();
  }
}

module.exports = apiController;


/** WEBPACK FOOTER **
 ** ./src/utils/api-controller.js
 **/